import $$ from "cmn-utils";
import { baseapi } from "../../../config";
// 示例
export function listCert(data) {
  return $$.post(
    baseapi+'/cert_api/public/v1/list_cert',data
  );
}
